import { render, staticRenderFns } from "./goldDes.vue?vue&type=template&id=39a07b20&scoped=true"
import script from "./goldDes.vue?vue&type=script&lang=js"
export * from "./goldDes.vue?vue&type=script&lang=js"
import style0 from "./goldDes.vue?vue&type=style&index=0&id=39a07b20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a07b20",
  null
  
)

export default component.exports